import TITLE from '../../config/title'
import axios from 'axios'
import Vue from 'vue'
// axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token')
axios.defaults.headers.common['Source'] = 'H5'
axios.defaults.headers.common['Duu-Client'] = 'H5'
/**
 * type 请求类型 不必须
 * url 请求地址
 * success 请求成功的参数
 * body 请求参数
 * unsuccess 请求失败的参数  不必须
 *  ###headers 请求头 不必须 默认设置  不要了
 * config 请求设置 请求头传里边
 * 401 重新登录  >=500服务器开小差
 */

function _http(option) {
  // console.log(sessionStorage.getItem('token'), this.cookies.get('token'))
  option.type = !option.type ? 'get' : option.type
  if (!option.config) {
    option.config = {
      headers: {
        Authorization: 'Bearer ' + (sessionStorage.getItem('token') || this.cookies.get('token'))
        // Source: 'Web'
      }
    }
  }
  if (option.type === 'post' || option.type === 'put' || option.type === 'patch') {
    axios[option.type](option.url, option.body, option.config)
      .then(function (response) {
        /* 以前采用resource 数据格式不一样 */
        var data = {}
        data.body = response.data
        option.success(data)
      })
      .catch(function (error) {
        // config  request  responseresponse
        console.log(error.response.data)
        option.unsuccess && option.unsuccess(error.response.data)
        if (error.response.status === 401 || error.response.data.code === 401) {
          console.log(error, '401')
        } else if (error.response.status === 500 || error.response.data.code === 500) {
          console.log(error, '500')
        } else if (error.response.status === 404 || error.response.data.code === 404) {
          console.log(error, '404')
        }
      })
  } else if (option.type === 'get' || option.type === 'head' || option.type === 'delete') {
    axios[option.type](option.url, option.config)
      .then(function (response) {
        /* 以前采用resource 数据格式不一样 */
        var data = {}
        data.body = response.data
        option.success(data)
      })
      .catch(function (error) {
        // config  request  response
        option.unsuccess && option.unsuccess(error.response)
        if (error.response.status === 401 || error.response.data.code === 401) {
          console.log(error, '401')
        } else if (error.response.status === 500 || error.response.data.code === 500) {
          console.log(error, '500')
        } else if (error.response.status === 404 || error.response.data.code === 404) {
          console.log(error, '404')
        }
      })
  }
}

/**
 * @param {string} title 标题
 * @param {stringstring} keyword 关键字
 * @param {string} description 描述
 */
function setMeta(title, keyword, description) {
  document.querySelector('title').innerHTML = title + TITLE.title
  var meta1 = document.createElement('meta')
  var meta2 = document.createElement('meta')
  meta1.name = 'keywords'
  meta1.content = keyword
  meta2.name = 'description'
  meta2.content = '17度(室内设计) 是专为用户提供写字楼室内设计、办公室内设计、办公空间室内设计的服务平台，包括纯写字楼、商业综合楼、商住两用楼、酒店写字楼、创意产业等室内设计服务，供需双方在线直接沟通、快速成交。'
  document.querySelector('head').appendChild(meta1)
  document.querySelector('head').appendChild(meta2)
}
// 404 页面
function notFound() {
  this.$router.push({
    path: '/'
  })
}

function setSession(name, data) {
  var str = ''
  if (typeof data === 'object') {
    str = JSON.stringify(data)
  } else {
    str = data + ''
  }
  window.sessionStorage.setItem(name, str)
}

function getSession(name) {
  var obj = window.sessionStorage.getItem(name)
  obj = JSON.parse(obj)
  return obj
}

function removeSession(name) {
  window.sessionStorage.removeItem(name)
}
/**
 * 设施类服务以及 踏勘
 * @param {number} statu   订单的状态
 * @param {string} isBuyer 买家还是商家 buyer seller
 * @param {string} number  订单号
 * @param {string} type  design 默认 construction
 */
function statuQuery(statu, isBuyer, number, type) {
  if (!type) {
    type = 'design'
  }
  var _this = this
  if (statu === -2) { // 订单被拒绝
  } else if (statu === -1) { // -1：订单待确认
    this.$router.push({
      path: `/services/${type}/orders/confirm/${isBuyer}/${number}`
    })
  } else if (statu === 0) { // 0：订单已确认（待支付）
    this.$router.push({
      path: `/services/${type}/orders/pay/${isBuyer}/${number}`
    })
  } else if (statu === 1) { // 1：已支付
    this.$router.push({
      path: `/services/${type}/orders/serve/${isBuyer}/${number}`
    })
  } else if (statu === 2) { // 2：待评价（已确认收货），
    this.$router.push({
      path: `/services/${type}/orders/finish/${isBuyer}/${number}`
    })
  } else if (statu === 3) { // 3：已完成（评价完成），
    this.$router.push({
      path: `/services/${type}/orders/finish/${isBuyer}/${number}`
    })
  } else if (statu === 7) { // 7：订单取消
    window.setTimeout(function () {
      _this.$router.push({
        path: `/services/${type}/orders/close/${number}`
      })
    }, 3000)
    // 订单已取消
    this.$message({
      showClose: true,
      message: '订单已取消！请重新下单',
      type: 'warning'
    })
  }
}

function getAvailableClock(detailData) {
  if (detailData.available_clock == '0,24' || !detailData.available_clock) {
    return []
  }
  var s = new Date()
  var arrScheduled = []
  var available_clock = detailData.available_clock.split(',')
  var sT = new Date(detailData.start_time.replace(/-/g, '/'))
  var eT = new Date(detailData.end_time.replace(/-/g, '/'))

  var monthDayArr = []
  // end_time   start_time
  for (var i = sT.getFullYear(); i <= eT.getFullYear(); i++) { // 从开始日期到结束日期
    if (isPinYear(i)) {
      monthDayArr = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    } else {
      monthDayArr = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]
    }
    if (i == sT.getFullYear()) {
      for (var j = sT.getMonth(); j < 12; j++) { // 每个月份
        for (var x = 0; x < monthDayArr[j]; x++) { // 月份中的每天    sT.getDate() - 1
          if (j == sT.getMonth() && sT.getDate() - 1 > x) {
            continue;
          }
          arrScheduled.push({
            start_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " 00:00:00",
            end_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + (available_clock[0] < 10 ? '0' + available_clock[0] : available_clock[0]) + ":00:00",
            title: '不可租'
          })
          arrScheduled.push({
            start_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + (available_clock[1] < 10 ? '0' + available_clock[1] : available_clock[1]) + ":00:00",
            end_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + "24:00:00",
            title: '不可租'
          })
          // console.count(1)
        }
      }
    } else if (i == eT.getFullYear()) {
      for (var j = 0; j < eT.getMonth() + 1; j++) { // 每个月份
        for (var x = 0; x < monthDayArr[j]; x++) { // 月份中的每天
          if (j == eT.getMonth() && x > eT.getDate() - 1) {
            continue;
          }
          arrScheduled.push({
            start_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " 00:00:00",
            end_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + (available_clock[0] < 10 ? '0' + available_clock[0] : available_clock[0]) + ":00:00",
            title: '不可租'
          })
          arrScheduled.push({
            start_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + (available_clock[1] < 10 ? '0' + available_clock[1] : available_clock[1]) + ":00:00",
            end_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + "24:00:00",
            title: '不可租'
          })
          // console.count(1)
        }
      }
    } else {
      for (var j = 0; j < 12; j++) { // 每个月份
        for (var x = 0; x < monthDayArr[j]; x++) { // 月份中的每天
          arrScheduled.push({
            start_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " 00:00:00",
            end_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + (available_clock[0] < 10 ? '0' + available_clock[0] : available_clock[0]) + ":00:00",
            title: '不可租'
          })
          arrScheduled.push({
            start_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + (available_clock[1] < 10 ? '0' + available_clock[1] : available_clock[1]) + ":00:00",
            end_time: i + "-" + ((j + 1) < 10 ? '0' + (j + 1) : (j + 1)) + "-" + ((x + 1) < 10 ? '0' + (x + 1) : (x + 1)) + " " + "24:00:00",
            title: '不可租'
          })
          // console.count(1)
        }
      }
    }
  }
  // console.log(new Date() - s )
  return arrScheduled
  
}

/**
 * 施工类
 * @param {*} statu
 * @param {*} who
 * @param {*} number
 * @param {*} type
 * @param {*} step
 */
function statuChange(statu, who, number, type, step) {
  if (statu === -2) { // 订单被拒绝
  } else if (statu === -1) { // -1：订单待确认
    this.$router.push({
      path: `/services/${type}/orders/sure/${who}/${number}`
    })
  } else if (statu === 0) { // 0：订单已确认（待支付）
    this.$router.push({
      path: `/services/${type}/orders/trusteeship/${who}/${number}`
    })
  } else if (statu === 1 || statu === 2 || statu === 3) { // 1：已支付
    this.$router.push({
      path: `/services/${type}/orders/locale/${who}/${number}`
    })
  } else if (statu === 2) { // 2：待评价（已确认收货），
    // this.$router.push({ path: `/services/${type}/orders/finish/${who}/${number}` })
  } else if (statu === 3) { // 3：已完成（评价完成），
    // this.$router.push({ path: `/services/${type}/orders/finish/${who}/${number}` })
  } else if (statu === 7) { // 7：订单取消
    window.setTimeout(function () {
      this.$router.push({
        path: `/services/${type}/orders/close/${number}`
      })
    }, 3000)
    // 订单已取消
    this.$message({
      showClose: true,
      message: '订单已取消！请重新下单',
      type: 'warning'
    })
  }
}

function StateRefund(option) {
  var _path = ''
  switch (option.statu) {
    case 0:
    case 1:
    case 2:
      _path = 'dispose'
      break;
    case 3:
      _path = 'platform'
      break;
  }
  if (_path) {
    this.$router.push({
      path: `/services/refund/${_path}/${option.who}/${option.order_number}`
    })
  }
}

// supporting
function plantsStatu(statu, who, number, item, type) {
  switch (statu) {
    case -1: // /services/supporting/orders/confirm/:type/:who/:order_number
      this.$router.push({
        path: `/services/${item}/orders/confirm/${type}/${who}/${number}`
      })
      break;
    case 0:
      this.$router.push({
        path: `/services/${item}/orders/pay/${type}/${who}/${number}`
      })
      break;
    case 1:
      this.$router.push({
        path: `/services/${item}/orders/serve/${type}/${who}/${number}`
      })
      break;
    case 12:
      this.$router.push({
        path: `/services/${item}/orders/receipt/${type}/${who}/${number}`
      })
      break;

    default:
      break;
  }
}

/**
 * 倒计时
 * @param {any} time  标准时间格式
 * @param {any} ss  倒计时时间 毫秒
 */
function countDown(date, time, ss) {
  let dd = +NewDate(time) + ss
  let timerID = setInterval(function () {
    var now = new Date()
    var remaining = +(dd) - +(now)
    var days = +remaining / 1000 / 60 / 60 / 24
    var daysRound = +Math.floor(days)
    var hours = +(remaining / 1000 / 60 / 60 - (24 * daysRound))
    var hoursRound = +Math.floor(hours)
    var minutes = +remaining / 1000 / 60 - (24 * 60 * daysRound) - (60 * hoursRound)
    var minutesRound = +Math.floor(minutes)
    var seconds = +remaining / 1000 - (24 * 60 * 60 * daysRound) - (60 * 60 * hoursRound) - (60 * minutesRound)
    date.d = +Math.floor(days) < 0 ? 0 : +Math.floor(days)
    date.h = +Math.floor(hours) < 0 ? 0 : +Math.floor(hours)
    date.m = +Math.floor(minutes) < 0 ? 0 : +Math.floor(minutes)
    date.s = +Math.floor(seconds) < 0 ? 0 : +Math.floor(seconds)

    date.d = +Math.floor(days) < 10 ? '0' + Math.floor(days) : +Math.floor(days)
    date.h = +Math.floor(hours) < 10 ? '0' + Math.floor(hours) : +Math.floor(hours)
    date.m = +Math.floor(minutes) < 10 ? '0' + Math.floor(minutes) : +Math.floor(minutes)
    date.s = +Math.floor(seconds) < 10 ? '0' + Math.floor(seconds) : +Math.floor(seconds)
    if (date.d == 0 && date.h == 0 && date.m == 0 && date.s == 0) {
      clearInterval(timerID)
    }
  }, 1000)

  function NewDate(str) {
    if (!str) return
    var day = str.split(' ')
    var days = day[0].split('-')
    var mi = day[day.length - 1].split(':')
    var date = new Date()
    date.setUTCFullYear(days[0], days[1] - 1, days[2])
    date.setUTCHours(mi[0] - 8, mi[1], mi[2])
    return date
  }
}

var cookies = {
  set: function (name, value) {
    var Days = 7;
    var exp = new Date();
    exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000)
    document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
  },
  get: function (name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
    if (arr = document.cookie.match(reg))
      return unescape(arr[2])
    else
      return null
  },
  del: function (name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = this.get(name);
    if (cval != null)
      document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
  }
}

/**
 *存储登录的用户信息
 *用户的登录令牌，用户组ID，自动生成的昵称
 */
function storeUserInfo(result, flag) {
  if (flag) {
    cookies.set('token', result.token)
  }
  sessionStorage.setItem('token', result.token)
  cookies.set('uid', result.uid) // 环信的ID
  cookies.set('tokenTime', new Date().getTime())
  cookies.set('nickname', result.nickname)
  cookies.set('huanxin_password', result.huanxin_password)
  cookies.set('identity', result.identity)
}

/*
  处理时间兼容性问题并显示为2017/6/7 16:00:00
*/
function newDate(strDate) {
  if ((typeof strDate) === 'string') {
    return strDate.replace(/-/g, '/')
  }
}
// 获取地址栏的参数
function getUrlPara(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
  var r = window.location.search.substr(1).match(reg)
  if (r != null) {
    return decodeURI(r[2])
  } else {
    return null
  }
}
// 对象转化为地址参数
function objToQuery(obj) {
  var arr = []
  for (var name in obj) {
    arr.push(encodeURIComponent(name) + '=' + encodeURIComponent(obj[name]));
  }
  return arr.join('&')
}
// 地址参数转化为对象
function queryToObj(url) {
  var obj = new Object()
  var arr = url.split('&')
  for (var i = 0; i < arr.length; i++) {
    obj[arr[i].split('=')[0]] = (arr[i].split('=')[1])
  }
  return obj
}
// 代替原生trim
function myTrim(x) {
  return x.replace(/^\s+|\s+$/gm, '');
}
// 获取短信验证码并进行倒计时功能
function setCountDown(obj) {
  var time = 60
  return function (obj) {
    var timer = setInterval(function () {
      if (time > 1) {
        time--
        time = time < 9 ? ('0' + time) : time
        obj.disabled = true
        obj.innerHTML = '重新获取(' + time + ')'
      } else {
        obj.innerHTML = '获取短信验证码'
        clearInterval(timer)
        obj.disabled = false
      }
    }, 1000)
    return timer
  }(obj)
}
// strDate 2017-6-28
function dayComputed(strDate2) {
  if ((typeof strDate2) === 'string') {
    var strDate2 = strDate2.replace(/-/g, '/')
    var strDate2 = strDate2.split(' ')[0]
    var strDate2 = new Date(strDate2)
    return strDate2
  }
}

function uid2Img(uid) {
  var pattern = /([0-9]+)$/ig;
  if (uid) {
    var i = uid.match(pattern);
    // return api.avatar+"uploads/avatar/"+toImgPath(i)+"_avatar.jpg?imageView2/1/w/100/h/100/format/jpg/q/100"+"&t="+cookies.get("iTime");
    return URL.AVATAR + "uploads/avatar/" + toImgPath(i) + "_avatar.jpg?imageView2/1/w/100/h/100/format/jpg/q/100" + "&t=" + (+new Date());
  } else {
    return URL.AVATAR + "uploads/avatar/default_avatar.jpg?imageView2/1/w/100/h/100/format/jpg/q/100";
  }
}
function toImgPath(uid) {
  var sum = 1000000000 + parseInt(uid);
  sum = sum.toString().substring(1, 10);
  var pathReg = /^([\d]{3})([\d]{2})([\d]{2})([\d]{2})$/g;
  var imgPath = sum.replace(pathReg, "$1/$2/$3/$4");
  return imgPath;
}

function isTelNumber(number) {
  var reg = /^1[3456789]\d{9}$/;
  return reg.test(number);
}

Vue.prototype._http = _http // 全局http请求
Vue.prototype.setMeta = setMeta // 设置关键字
Vue.prototype.notFound = notFound // 跳转404
Vue.prototype.setSession = setSession // 跳转404
Vue.prototype.getSession = getSession // 跳转404
Vue.prototype.removeSession = removeSession // 跳转404
Vue.prototype.statuQuery = statuQuery // 订单状态
Vue.prototype._countDown = countDown //
Vue.prototype._statuChange = statuChange //
Vue.prototype.cookies = cookies //
Vue.prototype.plantsStatu = plantsStatu //
Vue.prototype.StateRefund = StateRefund //
Vue.prototype.storeUserInfo = storeUserInfo //
Vue.prototype.newDate = newDate
Vue.prototype.getUrlPara = getUrlPara
Vue.prototype.objToQuery = objToQuery
Vue.prototype.queryToObj = queryToObj
Vue.prototype.setCountDown = setCountDown
Vue.prototype.myTrim = myTrim
Vue.prototype.dayComputed = dayComputed
Vue.prototype.getAvailableClock = getAvailableClock
Vue.prototype.uid2Img = uid2Img
Vue.prototype.isTelNumber = isTelNumber
Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}
export default {
  // _http,
  // setMeta,
  // notFound,
  // setSession,
  // getSession,
  // removeSession,
  // statuQuery,
  // countDown,
  // statuChange,
  // cookies,
  // plantsStatu
}



// WEBPACK FOOTER //
// ./src/assets/js/common.js